<template>
  <div v-if="state.type.value != 'all' || results.length > 0">
    <div class="flex justify-between items-center">
      <div class="text-xl font-bold">Governance</div>

      <div
        class="bg-white-010 p-2 rounded"
        @click="
          $router.push(`/dao/${daoPageInfo.vueState.info.daoPath}/Governance`)
        "
      >
        For More
      </div>
    </div>

    <div class="flex justify-between items-end my-4">
      <div class="flex space-x-4">
        <div v-for="(item, i) in baseInfo" :key="i">
          <div class="font-bold">{{ item.value }}</div>
          <div class="text-xs text-gray-level">{{ item.name }}</div>
        </div>
      </div>
      <UiDropdown
        class="w-24"
        v-model="state.type"
        :options="options"
      ></UiDropdown>
    </div>
    <div>
      <Proposals containerStyle="max-height: 820px" :type="state.type" />
    </div>
  </div>
</template>

<script setup>
import {
  queryGovernanceStatus,
  queryOvDaoProposal,
  queryOvVoteData,
} from '@/api/dao';
import UiDropdown from '@/components/UiDropdown.vue';
import { useReqByBool, useReqPages } from '@/hooks';
import { computed, inject, onMounted, reactive, watch, ref } from 'vue';
import UiImg from '@/components/UiImg.vue';
import {
  formatAddress,
  localeNumber,
  toExploreAddress,
  formatDateText,
  formatVal,
  jumpSnapshot,
} from '@/utils';
import { BackNetworkType } from '@/constants';
import { useInfiniteScroll } from '@vueuse/core';
import Spin from '@/components/Spin.vue';
import { withThrottling } from '@/utils/with';
import EnsAddress from '@/views/Home/component/EnsAddress.vue';
import { useRouter } from 'vue-router';
import Proposals from '../Proposals.vue';

const $router = useRouter();
const scroller = ref(null);

const options = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: 'active' },
  { label: 'Pending', value: 'pending' },
  { label: 'Closed', value: 'closed' },
];

const state = reactive({
  type: { label: 'All', value: 'all' },
  proposals: 0,
  voters: 0,
  votes: 0,
});

const baseInfo = computed(() => {
  return [
    {
      name: 'Proposals',
      value: localeNumber(state.proposals),
    },
    {
      name: 'Voters',
      value: localeNumber(state.voters),
    },
    {
      name: 'Votes',
      value: localeNumber(state.votes),
    },
  ];
});

const daoPageInfo = inject('daoPageInfo');

const { loadNext, loadRest, results, loading, isEmpty } = useReqPages(
  async (page, cancel) => {
    const res = await queryOvDaoProposal(
      daoPageInfo.vueState.info.id,
      page,
      state.type.value,
      cancel,
    );

    console.log('res.records', res.records);
    const result = {
      lists: res.records,
      rows: res.size,
      total: res.total,
      pages: res.pages,
    };
    return result;
  },
);

const { loadData } = useReqByBool(async () => {
  const res = await queryGovernanceStatus(daoPageInfo.vueState.info.id);
  if (res) {
    const { proposals, voters, votes } = res;
    state.proposals = proposals;
    state.voters = voters;
    state.votes = votes;
  }
  console.log(daoPageInfo);
});

useInfiniteScroll(scroller, withThrottling(loadNext), { distance: 44 });

watch(
  () => state.type.value,
  () => {
    loadRest(true);
  },
);

onMounted(() => {
  loadRest();
  loadData();
});
</script>

<style lang="scss" scoped></style>
